import React from "react";
import CrudPage from "../../components/admin/CrudPage";

const STATUS_OPTIONS = [
  { value: "pending", label: "Pendiente" },
  { value: "confirmed", label: "Confirmada" },
  { value: "shipped", label: "Enviada" },
  { value: "delivered", label: "Entregada" },
  { value: "cancelled", label: "Cancelada" },
];

const STATUS_MAP = {
  pending: { label: "Pendiente", color: "amber" },
  confirmed: { label: "Confirmada", color: "blue" },
  shipped: { label: "Enviada", color: "blue" },
  delivered: { label: "Entregada", color: "green" },
  cancelled: { label: "Cancelada", color: "red" },
};

const config = {
  title: "Pedidos",
  eyebrow: "Operaciones",
  resource: "orders",
  columns: [
    { key: "client_name", label: "Cliente" },
    { key: "status", label: "Estado", type: "status", statusMap: STATUS_MAP },
    { key: "items_count", label: "Items", type: "number" },
    { key: "total", label: "Total", type: "currency" },
    { key: "created_at", label: "Fecha", type: "date" },
  ],
  fields: [
    { key: "client_id", label: "ID cliente (UUID)", required: true },
    { key: "client_name", label: "Nombre del cliente", required: true },
    { key: "status", label: "Estado", type: "select", options: STATUS_OPTIONS, required: true },
    { key: "items_count", label: "# Items", type: "number" },
    { key: "total", label: "Total $", type: "number", required: true },
    { key: "notes", label: "Notas", type: "textarea" },
  ],
};

export default function AdminOrders() {
  return <CrudPage config={config} />;
}
